import React, { useEffect, useState } from 'react';
import { Col, Row, Modal, ModalBody, Form, Button, FormGroup } from 'reactstrap';
import { SelectForm, RadioForm, RadioFormAvaliacaoFormativa, InputForm } from '../Basicos';
import { axiosApi } from '../Basicos/axiosInstances';
import { MdAccessTime } from 'react-icons/md';
import ModalAlert from './ModalAlert';


export default function ModalAssociar({
    periodoLetivo, semestreId, turma, setBloquearBotao, bloquearBotao, criticar, aula, modalAssociarEstaAberto, aulas, setModalAssociarEstaAberto, Verificacao, horarioAulaId, observacao,
    localAluno, setLocalAluno,
    grupoIds, grupos, agregadorGrupo, handleAgregadorGrupo, horarioModal, handleGrupo, handleAulas, agregadorGruposOptions, updateServico, setAula,
    agregadorGruposValue, professores, handleProfessores, handleObservacao, handleTipoAvaliacaoFormativa, local, locais, handleLocal, setInicio, inicio, filtroProfessores, tipoAtividades,
    setServico, servico, ativarAlert, setObservacao, setHorarioModal, tipoAvaliacaoFormativa, tipoAvaliacaoFormativaOptions, tipoAvaliacaoFormativaValue, criticarServico, ativarCofirmacao,
    fim, setFim, intervaloInicio, setIntervaloInicio, intervaloFim, setIntervaloFim
}) {
    const [servicosOptions, setServicosOptions] = useState([]);
    const [grupoAlocadoId, setGrupoAlocadoId] = useState([]);
    const [professorServicoId, setProfessorServicoId] = useState();
    const [horarioAulaAtual, setHorarioAulaAtual] = useState();
    const [gruposDisponiveisServico, setGruposDisponiveisServico] = useState([]);
    const [gruposServicoAtual, setGruposServicoAtual] = useState([]);
    const [professoresServicoOptions, setProfessoresServicoOptions] = useState([]);
    const [ciclosOptions, setCiclosOptions] = useState([]);
    const [tipoAtividade, setTipoAtividade] = useState([]);
    const [ciclo, setCiclo] = useState();
    const [gruposDisponiveis, setGruposDisponiveis] = useState({
        gruposDisponiveis1: [],
        gruposDisponiveis2: [],
        gruposDisponiveis3: []
    });
    const [modalAlertAberto, setModalAlertAberto] = useState(false);
    const [mensagemAlert, setMensagemAlert] = useState("");

    const getGruposDisponiveis = async () => {
        try {
            if (!horarioModal?.id || !aula?.id) return;
            const { data } = await axiosApi.get(`/grupos-disponiveis?horario_oferta_id=${horarioModal.id}&aula_id=${aula.id}`);
            setGruposDisponiveis(data);
        } catch (error) {
            console.log(error);
            fecharModal();
            setMensagemAlert("Não foi possível carregar os grupos. Verifique se a quantidade de alunos do rodízio está em conformidade com a quantidade cadastrada na tela de Grupos de Aluno.");
            setModalAlertAberto(true);
        }
    }

    const aulasOptions = () =>
        aulas?.filter(aula => aula?.tipo_de_atividade_id === horarioModal?.tipo_atividade_id && aula?.tema_id === horarioModal?.tema_id)
            .map(aula => ({ value: aula?.id, label: aula?.sequencia_aula + "-" + aula?.titulo, professores: aula?.professores })) || [];

    // Fallback para quando a aula já associada não bate mais com o tema/tipo de atividade do slot
    // (ex: tema do slot foi alterado depois da associação) - sem isso o select fica vazio mesmo
    // com uma aula já vinculada, e o de Professor quebra em cascata.
    const aulaSelecionadaOption = () => {
        const encontrada = aulas?.find(elemento => elemento?.id === aula?.id);
        return encontrada
            ? { value: encontrada.id, label: encontrada.sequencia_aula + "-" + encontrada.titulo, professores: encontrada.professores }
            : undefined;
    };

    const aulasValue = () => aulasOptions().find(elemento => elemento.value === aula?.id) ?? aulaSelecionadaOption();

    const professoresOptions = () => aulasValue() ? aulasValue().professores
        .map(professor => ({ value: professor.id, label: professor.nome }))
        : []

    const professoresOptionsServico = () => [{ value: 0, label: horarioAulaAtual?.professores?.[0]?.nome }]

    const professoresValue = () => professores?.map(id => {
        return professoresOptions().find(elemento => elemento.value === id);
    })

    const localOptions = () => locais.map(local => ({ value: local?.id, label: local?.nome }));

    const localValue = () => localOptions().find(elemento => elemento.value === local?.id);

    const grupoIdsOptions = () => {
        const key = `gruposDisponiveis${agregadorGrupo}`;
        const listaGrupos = gruposDisponiveis[key] || [];
        return listaGrupos
            .filter(grupo => !grupoAlocadoId.includes(grupo.id))
            .map(grupo => ({ value: grupo.id, label: grupo.descricao }));
    }

    const grupoIdsValue = () => grupoIdsOptions().filter(elemento => grupoIds.includes(elemento.value));

    const styleInputs = {
        col: { xs: 12, sm: 12, md: 12, lg: 12, xl: 12 },
        col2: { xs: 6, sm: 6, md: 6, lg: 6, xl: 6 },
        col3: { xs: 4, sm: 4, md: 4, lg: 4, xl: 4 },
    }

    const duracaoMinima = horarioAulaAtual?.duracao_minima ?? aula?.duracao_minima;

    const tiposAtividadesServicos = tipoAtividades.filter(tp => tp.abreviatura == 'IPRA' || tp.abreviatura == 'VIV').map(tp => tp.id);

    const getCiclos = async () => {
        try {
            var turmaId = turma != null ? turma.id : 3;
            const { data } = await axiosApi.get(`/auxiliares/ciclo?tipo_atividade_id=${horarioModal?.tipo_atividade_id}&semestre_id=${semestreId}&periodo_letivo_id=${periodoLetivo?.id}&turma_id=${turmaId}`);
            setCiclosOptions(data?.dados?.map(el => ({ label: el.titulo, value: el.id })) || [])
        } catch (error) {
            console.log(error)
        }
    }

    const getServicos = async (cicloId) => {
        try {
            const { data } = await axiosApi.get(`/auxiliares/servicos-ciclo?ciclo_id=${cicloId}`);
            setServicosOptions(
                data.map(el => ({ label: el.descricao, value: el.id }))
            )
            if (horarioModal?.tipo_atividade_id == 14 || horarioModal?.tipo_atividade_id == 72) {
                const infos = await axiosApi.get(`/professores/lista-de-professores`);
                setProfessoresServicoOptions(infos.data.dados.map(el => ({ label: el.nome, value: el.id })))
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleGrupoServico = (input, value) => {
        let grupoRemovido = gruposServicoAtual.filter(item => !value.includes(item.value));

        setGruposDisponiveisServico(prevDisponiveis => [
            ...prevDisponiveis,
            ...grupoRemovido,
        ]);

        setGruposServicoAtual(prevAtuais =>
            prevAtuais.filter(item => value.includes(item.value))
        );

        let grupoAdicionado = gruposDisponiveisServico.find(
            item => value.includes(item.value) && !gruposServicoAtual.some(g => g.value === item.value)
        );

        if (grupoAdicionado) {
            setGruposServicoAtual(prevAtuais => [...prevAtuais, grupoAdicionado]);

            setGruposDisponiveisServico(prevDisponiveis =>
                prevDisponiveis.filter(item => item.value !== grupoAdicionado.value)
            );
        }
    }

    const getGrupos = async () => {
        try {
            var turmaId = turma != null ? turma.id : null;
            const { data } = await axiosApi.get(`/grupos-disponiveis-servico?turma_id=${turmaId}&periodo_letivo_id=${periodoLetivo?.id}&servico_id=${horarioAulaAtual?.servico_id}&horario_oferta_periodo_id=${horarioAulaAtual?.horario_oferta_perido_id}&oferta_periodo_letivo_id=${horarioAulaAtual?.horario_periodo?.oferta_periodo_letivos_id}&ciclo_id=${horarioAulaAtual?.ciclo_id}`)
            setGruposDisponiveisServico(data?.map(elemento => ({ value: elemento.id, label: elemento.descricao })) || [])
            setGruposServicoAtual(horarioAulaAtual?.grupos_por_aula?.map(elemento => ({ value: elemento.grupo_id, label: elemento?.grupo?.descricao })) || [])
        } catch (error) {
            console.log(error)
            fecharModal();
            setMensagemAlert("Não foi possível carregar os grupos. Verifique se a quantidade de alunos do rodízio está em conformidade com a quantidade cadastrada na tela de Grupos de Aluno.");
            setModalAlertAberto(true);
        }
    }

    const getTipoAtividade = async () => {
        try {
            const { data } = await axiosApi.get(`/tipo-atividade/${horarioModal?.tipo_atividade_id}`)
            setTipoAtividade(data.dados)
            if (horarioAulaId == null || horarioAulaId == undefined) {
                let avaliacao_formativa = data.dados.tipo_avaliacao_formativa_id == 1 ? "1" : "0"
                handleTipoAvaliacaoFormativa(parseInt(avaliacao_formativa))
            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        if (horarioAulaId == null || horarioAulaId == undefined) {
            getTipoAtividade();
        }
        if (modalAssociarEstaAberto) {
            setBloquearBotao(false)
            getCiclos();

            if (!tiposAtividadesServicos.includes(horarioModal?.tipo_atividade_id)) {
                getGruposDisponiveis();
            }

            const grupoAlocadoId = horarioModal?.horarios_aulas?.flatMap(ha => {
                if (ha.cancelada == false) {
                    if (ha.id == horarioAulaId) {
                        if (aula == null) {
                            const gruposDaAula = ha?.grupos_por_aula?.map(el => el.grupo)
                            handleGrupo(prev => gruposDaAula?.map(el => el.id))
                        }
                        setHorarioAulaAtual(ha)
                    }
                    if (ha.id != horarioAulaId) {
                        return ha.grupos_por_aula.map(ga => ga?.grupo_id);
                    }
                }
            });
            setGrupoAlocadoId(() => grupoAlocadoId);
        }
        else {
            //reseta valores ao fechar modal
            setServico();
            handleAgregadorGrupo(0);
            setGruposDisponiveis({
                gruposDisponiveis1: [],
                gruposDisponiveis2: [],
                gruposDisponiveis3: []
            });
            // handleGrupo(0); se funcionar ok remover
        }
    }, [modalAssociarEstaAberto, aula?.id, horarioAulaId]);

    useEffect(() => {
        if (horarioAulaAtual != undefined && horarioAulaAtual?.servico_id != null) {
            handleAgregadorGrupo(3)
            setProfessorServicoId(horarioAulaAtual.professores.map(professor => professor.id))
            getServicos(horarioAulaAtual.ciclo_id)
            getGrupos();
        }
    }, [horarioAulaAtual])

    const setCicloGetServico = async (value) => {
        setCiclo(value);
        getServicos(value);
    }

    const setServicoGetGrupos = async (value) => {
        try {
            setServico(value);
            var turmaId = turma != null ? turma.id : null;
            handleAgregadorGrupo(3)
            const { data } = await axiosApi.get(`/grupos-disponiveis-servico?turma_id=${turmaId}&periodo_letivo_id=${periodoLetivo.id}&servico_id=${value}&oferta_periodo_letivo_id=${horarioModal?.oferta_periodo_letivos_id}&ciclo_id=${ciclo}`)
            setGruposDisponiveisServico(data.map(elemento => ({ value: elemento.id, label: elemento.descricao })))
        } catch (error) {
            console.log(error);
            fecharModal();
            setMensagemAlert("Não foi possível carregar os grupos. Verifique se a quantidade de alunos do rodízio está em conformidade com a quantidade cadastrada na tela de Grupos de Aluno.");
            setModalAlertAberto(true);
        }
    }

    useEffect(() => {
        if (modalAssociarEstaAberto && !!aula) {
            //encontra os grupos da aula
            const gruposDaAula = horarioModal?.horarios_aulas?.find(el => el.id == horarioAulaId)?.grupos_por_aula?.map(el => el.grupo)
            //pega o tipo do grupo
            const tipoDeGrupo = gruposDaAula?.length && gruposDaAula[0].tipo_de_grupo_id
            //pega o servico da aula OBS so para Isec Pratico e Laboratorio Integrado
            const horario_aula = horarioModal?.horarios_aulas?.find(el => el.aula?.id == aula?.id)

            //seta o servico
            setServico(horario_aula?.servico_id || undefined)
            //seta o tipo do grupo
            handleAgregadorGrupo(prev => tipoDeGrupo || 0)
            //seta os ids dos grupos
            handleGrupo(prev => gruposDaAula?.map(el => el.id))
        }
    }, [modalAssociarEstaAberto])

    const executarSalvar = () => {
        if (aula != null)
            criticar(horarioModal)
        else {
            let arraySomenteValores = gruposServicoAtual.map(item => item.value);
            criticarServico(horarioModal, arraySomenteValores, ciclo)
            // updateServico(arraySomenteValores, ciclo)
        }
    }

    const validaForm = () => {
        if (!!aulasValue && !!inicio) {
            const ehTipoServico = tiposAtividadesServicos.includes(horarioModal?.tipo_atividade_id);
            if (ehTipoServico && gruposServicoAtual.length === 0) {
                ativarAlert(400, 'Não é possível salvar a aula sem grupos de alunos. Adicione pelo menos um grupo para prosseguir.');
                return;
            }
            executarSalvar();
        } else {
            ativarAlert(400, "Verifique campos obrigatórios")
        }
    }

    const professorServico = (input, value) => {
        setProfessorServicoId(value);
        handleProfessores(value)
    }

    const fecharModal = () => {
        setCiclo(undefined);
        setHorarioAulaAtual(undefined);
        setServico(undefined);
        setAula(undefined);
        setGruposServicoAtual([]);
        setObservacao(undefined);
        setLocalAluno(undefined);
        setProfessorServicoId(undefined);
        setInicio("");
        setFim("");
        setIntervaloInicio("");
        setIntervaloFim("");
        setModalAssociarEstaAberto(false);
    }

    console.log(horarioModal)

    return (
        <>
            <Modal isOpen={modalAssociarEstaAberto}>
                <ModalBody>
                    <Row className="menu-modal-formal">
                        <Col sm={12} className="align-content-middle mb-2 mt-2">
                            <h5><b>Associar Aula</b></h5>
                        </Col>
                    </Row>
                    <Form>
                        <Row form>
                            {
                                horarioModal?.tipo_atividade_id == 14 || horarioModal?.tipo_atividade_id == 72 ?
                                    <>
                                        <SelectForm
                                            name="ciclo_id"
                                            label="Ciclo"
                                            value={ciclosOptions.find(el => el.value == (ciclo == undefined ? horarioAulaAtual?.ciclo_id : ciclo))}
                                            options={ciclosOptions}
                                            onChange={(input, value) => setCicloGetServico(value)}
                                            colunaClass="px-0"
                                            style={{ col: { ...styleInputs.col } }}
                                            isRequired={true}
                                        />
                                        <SelectForm
                                            name="servico_id"
                                            label="Serviço"
                                            value={servicosOptions.find(el => el.value == (servico == undefined ? horarioAulaAtual?.servico_id : servico))}
                                            options={servicosOptions}
                                            onChange={(input, value) => setServicoGetGrupos(value)}
                                            colunaClass="px-0"
                                            style={{ col: { ...styleInputs.col } }}
                                            isRequired={true}
                                        />
                                        <SelectForm
                                            isMulti
                                            name="professor_id"
                                            label="Professor"
                                            value={professoresServicoOptions.find(el => el.value == professorServicoId)}
                                            options={professoresServicoOptions}
                                            onChange={(input, value) => professorServico(input, value)}
                                            colunaClass="px-0"
                                            isRequired={true}
                                            style={{ col: { ...styleInputs.col } }}
                                        />
                                    </>
                                    :
                                    <>
                                        <SelectForm
                                            name="aula_id"
                                            label="Aula"
                                            value={aulasValue()}
                                            options={aulasOptions()}
                                            onChange={(input, value) => handleAulas(value)}
                                            colunaClass="px-0"
                                            isRequired={true}
                                            style={{ col: { ...styleInputs.col } }}
                                        />
                                        <SelectForm
                                            isMulti
                                            name="professor_id"
                                            label="Professor"
                                            value={professoresValue()}
                                            options={professoresOptions()}
                                            onChange={(input, value) => handleProfessores(value)}
                                            colunaClass="px-0"
                                            isRequired={true}
                                            style={{ col: { ...styleInputs.col } }}
                                        />
                                    </>
                            }
                            <SelectForm
                                name="local_id"
                                label="Local"
                                value={localValue() ?? { label: 'Selecione', value: 'Selecione' }}
                                options={localOptions()}
                                onChange={(input, value) => handleLocal(value)}
                                colunaClass="px-0"
                                isRequired={true}
                                style={{ col: { ...styleInputs.col } }}
                            />
                            {
                                horarioModal?.tipo_atividade_id != 14 && horarioModal?.tipo_atividade_id != 72 &&
                                tiposAtividadesServicos.includes(horarioModal?.tipo_atividade_id) &&
                                <SelectForm
                                    name="servico_id"
                                    label="Serviço"
                                    value={servicosOptions.find(el => el.value == servico)}
                                    options={servicosOptions}
                                    onChange={(input, value) => setServico(value)}
                                    colunaClass="px-0"
                                    style={{ col: { ...styleInputs.col } }}
                                    isRequired={true}
                                />
                            }
                            <InputForm
                                type="text"
                                label="Duração"
                                name="duracao_minima"
                                value={duracaoMinima != undefined ? `${duracaoMinima}h` : ''}
                                onChange={(e) => console.log(e.target.name)}
                                colunaClass="px-0"
                                isRequired={true}
                                style={{ col: { ...styleInputs.col3 } }}
                                readOnly
                            />
                            <InputForm
                                type="time"
                                label="Inicio"
                                name="inicio"
                                id="inicio"
                                value={inicio}
                                onChange={(index, value) => {
                                    setInicio(value)
                                }}
                                colunaClass="px-0"
                                style={{ col: { ...styleInputs.col3 } }}
                                isRequired={true}
                            />
                            <InputForm
                                type="time"
                                label="Fim"
                                icon={<MdAccessTime />}
                                name="fim"
                                id="fim"
                                value={fim}
                                onChange={(index, value) => {
                                    setFim(value)
                                }}
                                colunaClass="px-0"
                                style={{ col: { ...styleInputs.col3 } }}
                                isRequired={true}
                                readOnly
                            />
                            {
                                duracaoMinima == 4 &&
                                <>
                                    <InputForm
                                        type="time"
                                        label="Intervalo Início"
                                        icon={<MdAccessTime />}
                                        name="intervalo_inicio"
                                        id="intervalo_inicio"
                                        value={intervaloInicio}
                                        onChange={(index, value) => {
                                            setIntervaloInicio(value)
                                        }}
                                        colunaClass="px-0"
                                        style={{ col: { ...styleInputs.col2 } }}
                                        isRequired={true}
                                        readOnly
                                    />
                                    <InputForm
                                        type="time"
                                        label="Intervalo Fim"
                                        icon={<MdAccessTime />}
                                        name="intervalo_fim"
                                        id="intervalo_fim"
                                        value={intervaloFim}
                                        onChange={(index, value) => {
                                            setIntervaloFim(value)
                                        }}
                                        colunaClass="px-0"
                                        style={{ col: { ...styleInputs.col2 } }}
                                        isRequired={true}
                                        readOnly
                                    />
                                </>
                            }
                            <RadioForm
                                name="grupo_agregador_id"
                                label="Grupo de Alunos"
                                value={agregadorGruposValue()}
                                options={agregadorGruposOptions()}
                                valorPadrao={agregadorGrupo.toString()}
                                onChange={(input, value) => handleAgregadorGrupo(parseInt(value))}
                                style={{ col: { ...styleInputs.col } }}
                            />
                            <RadioFormAvaliacaoFormativa
                                name="avaliacao_formativa"
                                label="Avaliação Formativa"
                                options={tipoAvaliacaoFormativaOptions()}
                                valorPadrao={horarioAulaAtual != undefined ?
                                    horarioAulaAtual.avaliacao_formativa == true ? "1" : "0" :
                                    tipoAvaliacaoFormativa
                                }
                                onChange={(input, value) => handleTipoAvaliacaoFormativa(parseInt(value))}
                                style={{ col: { ...styleInputs.col } }}
                            />
                            {
                                agregadorGrupo !== 0
                                    ?
                                    horarioModal?.tipo_atividade_id == 14 || horarioModal?.tipo_atividade_id == 72 ?
                                        <SelectForm
                                            name="grupos_ids"
                                            label="Grupos"
                                            value={gruposServicoAtual}
                                            options={gruposDisponiveisServico}
                                            onChange={(input, value) => handleGrupoServico(input, value)}
                                            isMulti
                                            colunaClass="px-0"
                                            style={{ col: { ...styleInputs.col } }}
                                            isRequired={true}
                                        /> : <SelectForm
                                            name="grupos_ids"
                                            label="Grupos"
                                            value={grupoIdsValue()}
                                            options={grupoIdsOptions()}
                                            onChange={(input, value) => handleGrupo(value)}
                                            isMulti
                                            colunaClass="px-0"
                                            style={{ col: { ...styleInputs.col } }}
                                            isRequired={true}
                                        />
                                    : null
                            }
                            {
                                (tiposAtividadesServicos.includes(horarioModal?.tipo_atividade_id)) &&
                                <InputForm
                                    type="text"
                                    label="Local Aluno"
                                    name="local_aluno"
                                    id="local_aluno"
                                    value={localAluno || ""}
                                    onChange={(index, value) => setLocalAluno(value)}
                                    colunaClass="px-0"
                                    style={{ col: { ...styleInputs.col } }}
                                    maxLength={255}
                                />
                            }
                            <InputForm
                                type="textarea"
                                label="Observação"
                                name="observacao"
                                id="observacao"
                                value={observacao}
                                onChange={(index, value) => handleObservacao(value)}
                                colunaClass="px-0"
                                style={{ col: { ...styleInputs.col } }}
                                isRequired={true}
                            />
                            <Row className="contagem-caracteres">
                                {observacao?.length}/255
                            </Row>
                        </Row>
                    </Form>
                    <Col sm={12} className="align-content-middle mb-3 p-0">
                        <Button
                            onClick={() => fecharModal()}
                            className="float-right btn-transparente"
                        >
                            Cancelar
                        </Button>
                        <Button onClick={bloquearBotao ? '' : () => validaForm()} className="float-right">Salvar</Button>
                    </Col>
                </ModalBody>
            </Modal>
            <ModalAlert
                isOpen={modalAlertAberto}
                setIsOpen={setModalAlertAberto}
                titulo="Atenção"
                mensagem={mensagemAlert}
            />
        </>
    );
}
